import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { SignInRecordListParams, SignInRecordListDetailParams } from '@/typings/api/systemSetting'

/**
 * **************************************  **************************************
 */
// 分页查询签到记录列表
export function signInRecordList(data:SignInRecordListParams) {
  return request.post<AxiosResult>('/base/api/signInRecord/findByPage', data)
}
// 查询签到详情
export function signInRecordDetail(data:SignInRecordListDetailParams) {
  return request.post<AxiosResult>('/base/api/signInRecord/getById', data)
}
// 查询签到详情
export function signInRecordDelete(data:SignInRecordListDetailParams) {
  return request.post<AxiosResult>('/base/api/signInRecord/delete', data)
}
